import { useMemo } from "react";
import { Alert, Box, List, ListSubheader, Typography } from "@mui/material";
import OutlinedCard from "components/OutlinedCard";
import PageLayout from "components/PageLayout";
import PageTitle from "components/PageTitle";
import Spinner from "features/spinner/Spinner";
import { useGetMyBookingsQuery } from "app/api/users";
import BookingItem from "./components/BookingItem";
import { formatLongDate } from "utilities/formatDate";
import { groupBookingsByDate } from "./util/groupBookingsByDate";

const BookingsPage: React.FC = () => {
  const { data: bookings, isLoading, isError } = useGetMyBookingsQuery();
  const grouped = useMemo(() => groupBookingsByDate(bookings ?? []), [bookings]);

  return (
    <PageLayout>
      <PageTitle>Bokningar</PageTitle>

      {isLoading && (
        <OutlinedCard>
          <Box sx={{ display: "grid", placeItems: "center", gap: 1, py: 1 }}>
            <Spinner size="3rem" color="#5f5f5f80" />
            <Typography>Hämtar bokningar...</Typography>
          </Box>
        </OutlinedCard>
      )}

      {isError && (
        <OutlinedCard>
          <Alert severity="error">Kunde inte hämta bokningar</Alert>
        </OutlinedCard>
      )}

      <List sx={{ display: "grid", gap: 1 }}>
        {Array.from(grouped.entries()).map(([date, bookings]) => (
          <>
            <ListSubheader
              disableSticky
              sx={{
                mt: 1,
                px: 1,
                color: "text.primary",
                bgcolor: "transparent",
                fontWeight: "bold",
                lineHeight: "unset",
                fontSize: "large",
              }}
            >
              {formatLongDate(new Date(date))}
            </ListSubheader>

            {bookings?.map((booking) => (
              <BookingItem key={booking.id} booking={booking} />
            ))}
          </>
        ))}
      </List>
    </PageLayout>
  );
};

export default BookingsPage;
